﻿export class FlexSlider extends HTMLElement {
  connectedCallback() {
    const sliderColor = getComputedStyle(
      document.documentElement,
    ).getPropertyValue('--slider-track-color');
    const rangeColor = getComputedStyle(
      document.documentElement,
    ).getPropertyValue('--slider-range-color');
    const fromSlider = this.children.length > 1 ? this.firstElementChild : null;
    const toSlider = this.lastElementChild;
    const fromInput = document.getElementById(this.getAttribute('fromInput'));
    const toInput = document.getElementById(this.getAttribute('toInput'));
    const fromText = document.getElementById(this.getAttribute('fromText'));
    const toText = document.getElementById(this.getAttribute('toText'));
    const isDual = fromSlider != null;

    function controlFromInput() {
      const [from, to] = getParsed(fromInput, toInput);
      if (from > to) {
        fromSlider.value = to;
        setFromInput(to);
      } else {
        fromSlider.value = from;
      }
      updateText();
      fillSlider(fromSlider, toSlider, toSlider);
    }

    function updateText() {
      if (toText != null) {
        toText.innerText = toSlider.value;
      }

      if (isDual && fromText != null) {
        fromText.innerText = fromSlider.value;
      }
    }

    function controlToInput() {
      if (isDual) {
        const [from, to] = getParsed(fromInput, toInput);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          setToInput(to);
        } else {
          setToInput(from);
        }
      } else {
        toSlider.value = toInput.value;
      }
      updateText();
      fillSlider(fromInput, toInput, toSlider);
    }

    function controlFromSlider() {
      if (isDual) {
        const [from, to] = getParsed(fromSlider, toSlider);

        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          setFromInput(from);
        }
        updateText();
        fillSlider(fromSlider, toSlider, toSlider);
      }
    }

    function controlToSlider() {
      if (isDual) {
        const [from, to] = getParsed(fromSlider, toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          setToInput(to);
        } else {
          setToInput(from);
          toSlider.value = from;
        }
      } else {
        setToInput(toSlider.value);
      }
      updateText();
      fillSlider(fromSlider, toSlider, toSlider);
    }
    function setToInput(value) {
      if (toInput != null) {
        toInput.value = value;
      }
    }
    function setFromInput(value) {
      if (fromInput != null) {
        fromInput.value = value;
      }
    }
    function getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }

    function fillSlider(from, to, controlSlider) {
      const rangeDistance = to.max - to.min;

      if (isDual) {
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
                to right,
                ${sliderColor} 0%,
                ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
                ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
                ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
                ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
                ${sliderColor} 100%)`;
      } else {
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
                to right,
                ${rangeColor} 0%,
                ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
                ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
                ${sliderColor} 100%)`;
      }
    }

    function setToggleAccessible(currentTarget) {
      if (Number(currentTarget.value) <= 0) {
        toSlider.style.zIndex = 2;
      } else {
        toSlider.style.zIndex = 0;
      }
    }

    fillSlider(fromSlider, toSlider, toSlider);
    setToggleAccessible(toSlider);

    if (fromSlider) {
      fromSlider.addEventListener('input', () => {
        controlFromSlider();
      });
    }
    toSlider.addEventListener('input', () => {
      controlToSlider();
    });

    if (fromInput) {
      fromInput.addEventListener('input', () => {
        controlFromInput();
      });
    }
    if (toInput) {
      toInput.addEventListener('input', () => {
        controlToInput();
      });
    }

    updateText();
  }
}
customElements.define('flex-slider', FlexSlider);
